import { object, string, type InferType } from "yup";
import { isUSA } from "../../../../common/utils";
import { AddressInputSchemaGenerator } from "../../../SharedAddressInput/constants";
import { getNameFromCountry } from "../../mappers";

export enum CheckPaymentPrefInputFields {
  Memo = "memo",
  PayeeName = "payeeName",
  Address = "address",
}

const BaseSchema = object().shape({
  [CheckPaymentPrefInputFields.PayeeName]: string()
    .max(80, "Payee name must be 80 characters or less")
    .required("Required field"),
  [CheckPaymentPrefInputFields.Memo]: string().max(40, "Memo must be 40 characters or less"),
});

export const CheckPaymentPrefInputSchema = BaseSchema.concat(
  object().shape({
    [CheckPaymentPrefInputFields.Address]: AddressInputSchemaGenerator({
      testIsUSA: (country) => isUSA(getNameFromCountry(country)),
    }),
  }),
);

export type CheckPaymentPrefInputType = InferType<typeof CheckPaymentPrefInputSchema>;
